
import Template from './Template'


class BigTemplate extends Template{
    constructor(arg = {
        // campaignList: [],
        unit: {}
    }) {
        super(arg)

        // 表明当前模板如果要成功加载, 至少需要多少个 campaign
        this.expectCampaignNumber = 2

        // 存储通过当前大模板创建的子模板列表
        this.tplList = []
        this.tplIndexList = []

        this.unit = arg.unit || {}

        this.campaignList = []
    }

    setSubTpls(campaignList, tplClass){
        campaignList.forEach((campaign)=>{
            const videoTpl = new tplClass({
                            campaign,
                            unit: this.unit
                       })
            //vt.init(campaign, data)
            this.campaignList.push(campaign)
            this.addVideoTpl(videoTpl)
        })
    }

    initComponents() {
        this.webview = Webview.getInstance()
        this.playerView = PlayerView.getInstance()
        webview.append(playerView)
    }

    // 构建大模板实例
    getRootBigTemplateInstance(instanceId, unit_id) {
        return {
            type: 1, // 大模板的 ViewType 固定为 1
            id: instanceId,
            unitid: unit_id,
            isRootBigTemplate: true
        }
    }

    allTplPreloadFinished() {
        let isAllFinished = true
        for (let curTplItem of this.tplIndexList) {
            if (curTplItem.isPageLoadFinished === false) {
                isAllFinished = false
            }
        }
        return isAllFinished
    }

    show(res) {
        // "cmpt"：cmpt,子视图
        // "rect":{"top":10,"bottom":20,"left":20,"right":30"width":320,"height":480}//width,height不传 则为父视图宽高
        super.show(res)
    }

    registerPageHandler() {
        window.mtg_fn_showVideoTemplateLegacy = () => {

        }
    }

    setDatas(dataSource) {
        const {campaignList, unitSetting} = dataSource
        this.campaignList = campaignList
        this.unitSetting = unitSetting
        this.unitId = unitSetting.unitId
        this.dataSource = dataSource
    }

    addVideoTpl(tpl) {
        this.tplList.push(tpl)
    }

    removeVideoTpl(tpl) {
        let index = -1
        if (typeof tpl === "number") {
            index = tpl
        } else if (typeof tpl === "object") {
            index = this.tplList.indexOf(tpl)
        }
        if (index > -1) {
            this.tplList.splice(index, 1)
        }
    }

    clearnAllVideoTpl() {
        this.tplList = []
    }
}

export default BigTemplate